import update from 'immutability-helper';

import { ActionType, defaultAction } from '../types';
import { ACTION_TYPES } from '../types/signLegalDocumentType';
const initialState = {
  showModal: false,
};

export default (state = initialState, action: ActionType = defaultAction) => {
  const { type } = action;

  switch (type) {
    case ACTION_TYPES.SHOW_MODAL:
      return update(state, { showModal: { $set: true } });
    case ACTION_TYPES.CLOSE_MODAL:
      return update(state, { showModal: { $set: false } });
    default:
      return state;
  }
};
